import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { Breadcrumb, Col, Divider, Row, Space, Spin } from 'antd'
import { isEmpty } from 'lodash'

import { UpdateDataText } from '../../../core/components/sections'

import { HistoryLink } from '../../../common/components/sections'
import { StyledPageSubTitle } from '../../../common/components/styled'
import {
  APP_ROUTES,
  EVENT_METADATA_TYPES,
  EVENT_TYPES,
  METADATA_TYPES,
} from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import {
  useDishTypesQuery,
  useDocumentTitle,
  useUpdatedIngredientSubscription,
} from '../../../common/hooks'

import { renderFoodMoodEvent } from '../../helpers'
import { useFoodMoodQuery } from '../../hooks'
import {
  FoodMoodImageDetailsForm,
  FoodMoodRelationsDetailsForm,
  FoodMoodSimpleDetailsForm,
} from '../forms'

const FoodMoodDetailsPage = () => {
  const { id } = useParams()

  const isFoodMoodPageDirty = useSelector(
    store =>
      store.foodMoods.foodMood.isImageDetailsLoading ||
      store.foodMoods.foodMood.isRelationsDirty ||
      store.foodMoods.foodMood.isSimpleDetailsDirty,
  )

  const {
    isLoading: isFetchLoading,
    error: fetchError,
    data,
    refetch,
  } = useFoodMoodQuery(id)

  useUpdatedIngredientSubscription(
    id,
    isFoodMoodPageDirty,
    METADATA_TYPES.FOOD_MOODS.value,
    refetch,
  )

  const {
    data: dishTypes,
    // options: dishTypesOptions,
    isLoading: isLoadingDishTypes,
    error: dishTypesError,
  } = useDishTypesQuery()

  useDocumentTitle(`${data?.name || 'Loading Food Mood...'}`)

  useEffect(() => {
    if (fetchError || dishTypesError) {
      showErrorNotification({
        title: 'Food Mood error',
        description: fetchError || dishTypesError,
      })
    }
  }, [dishTypesError, fetchError])

  return isFetchLoading || isLoadingDishTypes || isEmpty(data) ? (
    <Spin />
  ) : (
    <>
      <StyledPageSubTitle>
        <Row justify="space-between">
          <Col span={12}>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link
                  to={APP_ROUTES.MOBILE_APP_ONLY.subMenuItems.FOOD_MOODS.link}
                >
                  {APP_ROUTES.MOBILE_APP_ONLY.subMenuItems.FOOD_MOODS.name}
                </Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>
                <Link
                  to={`${APP_ROUTES.MOBILE_APP_ONLY.subMenuItems.FOOD_MOODS.link}/${data.id}`}
                >
                  {data.name}
                </Link>
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>

          <Space>
            <UpdateDataText
              updatedAt={data.updatedAt}
              updatedBy={data.updatedBy?.name}
            />

            <HistoryLink
              renderEvent={renderFoodMoodEvent}
              entityId={id}
              eventTypes={[EVENT_TYPES.UPDATE]}
              eventMetadataTypes={[EVENT_METADATA_TYPES.FOOD_MOOD]}
            />
          </Space>
        </Row>
      </StyledPageSubTitle>
      <FoodMoodSimpleDetailsForm
        foodMood={data}
        maxPosition={data.maxPosition}
      />
      <Divider />
      <FoodMoodImageDetailsForm foodMood={data} />
      <Divider />
      {!isEmpty(dishTypes) && (
        <FoodMoodRelationsDetailsForm
          foodMood={data}
          dishTypeOptions={dishTypes}
        />
      )}
    </>
  )
}

export default FoodMoodDetailsPage
